import { useStyletron } from 'baseui'

const useHomeStyles = () => {
  const [css, theme] = useStyletron()
  const cardBonuses = css({
    padding: '1rem',
    marginBottom: '2rem',
    background: theme.colors.bg050,
    borderRadius: '1rem',
    boxShadow: '0 2px 6px rgba(20,96,170,.3)',
  })
  const child = css({
    flex: 1,
    width: '50%',
    margin: '0.2rem',
  })

  return {
    cardBonuses,
    child,
  }
}

export default useHomeStyles
